import { createContext, useContext } from "react";

export const DEFAULT_CC_NOTICE = {
  enabled: true,
  percent: 3,
  text: "3% EXTRA ON ALL CREDIT CARD PURCHASES",
  animate: true,
  show: { home: true, product: true, catalog: true, footer: true, inquiry: true },
};

const NoticeContext = createContext(DEFAULT_CC_NOTICE);
export const NoticeProvider = NoticeContext.Provider;
export const useCcNotice = () => useContext(NoticeContext);

const ReviewLinkContext = createContext("");
export const ReviewLinkProvider = ReviewLinkContext.Provider;
export const useReviewLink = () => useContext(ReviewLinkContext);
